<template>
  <div class="">
  <img width="60" height="60" :src="imgURL?imgURL:placeholder"/>
                
  </div>
</template>

<script>
import {
  COMPONENT_NAME,
  ORDER,
  PATHNAME,
  DATE_TIME_FORMAT,
} from "../../../../util/constants";
import BaseConfiguration from "../../../../config/base";
export default {

    name:COMPONENT_NAME.C_HOTEL_THUMBNAIL,


    props:{

        imgURL:{
            type:String,
            deafult:null
        }


    },
    data:()=>{
        return{
            placeholder:BaseConfiguration.hmsDefaultHotelImg
        }
    },





}
</script>

<style>

</style>